export const multiVendorRequestsPath = "/multi-vendor-requests";
export const multiVendorRequestsListPath = multiVendorRequestsPath;
export const multiVendorRequestPath = (id: string) => `${multiVendorRequestsPath}/${id}`;
